
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kik",
      function () {
        return require("private-next-pages/kik/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kik"])
      });
    }
  